import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import EquipOffice from "@/pages/EquipOffice";
import SearchAsset from "@/pages/SearchAsset";
import SearchSurplus from "@/pages/SearchSurplus";
import UploadAsset from "@/pages/UploadAsset";
import AssetDetail from "@/pages/AssetDetail";
import Projects from "@/pages/Projects";
import Leaderboard from "@/pages/Leaderboard";
import ProjectImpact from "@/pages/ProjectImpact";
import MyRecognition from "@/pages/MyRecognition";
import Employees from "@/pages/Employees";
import EmployeeProfile from "@/pages/EmployeeProfile";
import Novedades from "@/pages/Novedades";
import MiEspacio from "@/pages/MiEspacio";
import CommentBox from "@/pages/CommentBox";
import ReuseConversation from "@/pages/ReuseConversation";
import AppAdmin from "@/pages/AppAdmin";
import AdminInventory from "@/pages/AdminInventory";
import AdminStaff from "@/pages/AdminStaff";
import AdminProjects from "@/pages/AdminProjects";
import Layout from "@/components/layout/Layout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-[#5C6A7D]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/equip-office" element={<Protected><EquipOffice /></Protected>} />
          <Route path="/search" element={<Protected><SearchAsset /></Protected>} />
          <Route path="/surplus" element={<Protected><SearchSurplus /></Protected>} />
          <Route path="/upload" element={<Protected><UploadAsset /></Protected>} />
          <Route path="/assets/:id" element={<Protected><AssetDetail /></Protected>} />
          <Route path="/reuse-requests/:id" element={<Protected><ReuseConversation /></Protected>} />
          <Route path="/admin" element={<Protected><AppAdmin /></Protected>} />
          <Route path="/admin/inventario" element={<Protected><AdminInventory /></Protected>} />
          <Route path="/admin/staff" element={<Protected><AdminStaff /></Protected>} />
          <Route path="/admin/proyectos" element={<Protected><AdminProjects /></Protected>} />
          <Route path="/projects" element={<Protected><Projects /></Protected>} />
          <Route path="/projects/:id/impact" element={<Protected><ProjectImpact /></Protected>} />
          <Route path="/leaderboard" element={<Protected><Leaderboard /></Protected>} />
          <Route path="/employees" element={<Protected><Employees /></Protected>} />
          <Route path="/employees/:id" element={<Protected><EmployeeProfile /></Protected>} />
          <Route path="/novedades" element={<Protected><Novedades /></Protected>} />
          <Route path="/mi-espacio" element={<Protected><MiEspacio /></Protected>} />
          <Route path="/buzon" element={<Protected><CommentBox /></Protected>} />
          <Route path="/me" element={<Protected><MyRecognition /></Protected>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
